$(document).ready(function () {
  ("use strict");
  $('.num-counter').each(function() {
    var element = $(this);
    element.addClass('hidden');
    element.viewportChecker({
      classToAdd: 'visible',
      callbackFunction: function () {
        element.prop('Counter', 0).animate({
          Counter: element.text().replace(/\./g, '')
          //Counter: 65139
        }, {
          duration: 2000,
          easing: 'swing',
          step: function (now) {
            element.text(Math.ceil(now).toLocaleString('ca-ES'));
          }
        });
      }
    });
  });
});
$(document).ready(function () {
  ("use strict");
  $('.num-counter-decimal').each(function() {
    var element = $(this);
    element.addClass('hidden');
    element.viewportChecker({
      classToAdd: 'visible',
      callbackFunction: function () {
        var info = element.text().replace(/\./g, '').replace(',', '.').split(".");
        var counter = info[0];
        var sufix = '';
        if (typeof info[1] != 'undefined') {
          sufix = ','+info[1]
        }
        element.prop('Counter', 0).animate({
          Counter: counter
          //Counter: 65139
        }, {
          duration: 2000,
          easing: 'swing',
          step: function (now) {
            element.text(Math.ceil(now).toLocaleString('ca-ES')+sufix);
          }
        });
      }
    });
  });
});
